<template>
  <a-drawer width="40%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本名称" prop="scriptName" >
        <a-button type="dashed" @click="showBindScript" danger v-if="form.scriptName" :disabled="formType === 2">
          <span>{{ form.scriptName }}</span>
        </a-button>
        <a-button type="dashed" @click="showBindScript" danger v-if="!form.scriptName" :disabled="formType === 2">
          <span style="color: dodgerblue"> 绑定剧本</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="横幅图片" prop="bannerImg" >
        <oss-multi-upload
          v-model="form.bannerImg"
          type="img"
          bucket="played/shop/script/banner"
          :isMultiple="true"
        ></oss-multi-upload>
<!--        <a-input v-model="form.bannerImg" placeholder="请输入内容" type="textarea" allow-clear />-->
      </a-form-model-item>
      <a-form-model-item label="申领方式" prop="applyWay" >
        <a-select style="width: 250px" v-model="form.applyWay" placeholder="请设置申领方式">
          <a-select-option :value="1">免费申领</a-select-option>
          <a-select-option :value="2">预购x车</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="免费申领切换到预购的阈值" prop="freeToPreorderThreshold" >
        <a-input-number v-model="form.freeToPreorderThreshold" :min="0" :step="1" :precision="0" placeholder="请输入免费申领切换到预购的阈值" />
      </a-form-model-item>
      <a-form-model-item label="预购车数量" prop="preOrderCarNum" >
        <a-input-number v-model="form.preOrderCarNum" :min="0" :max="999" placeholder="请输入预购车数量" />
      </a-form-model-item>
      <a-form-model-item label="再领一本数量" prop="anotherCount" >
        <a-input-number v-model="form.anotherCount" :min="0" :step="1" :precision="0" placeholder="请输入再领一本数量" />
      </a-form-model-item>
      <a-row :gutter="48">
        <a-col :span="8">
          <a-form-model-item label="一线城市开本价格" prop="firstCityPrices" >
            <a-input-number v-model="form.firstCityPrices" :min="20" :max="1000" placeholder="请输入一线城市开本价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="一线城市预购X车价格" prop="firstCityPreOrderPrices" >
            <a-input-number v-model="form.firstCityPreOrderPrices" :min="0" :step="1" :precision="0" placeholder="请输入一线城市预购X车价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="一线城市再领一本价格" prop="firstCityOrderPrices" >
            <a-input-number v-model="form.firstCityOrderPrices" :min="20" :max="1000" placeholder="请输入一线城市再领一本价格" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="48">
        <a-col :span="8">
          <a-form-model-item label="新一线城市开本价格" prop="newFirstCityPrices" >
            <a-input-number v-model="form.newFirstCityPrices" :min="20" :max="1000" placeholder="请输入新一线城市开本价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="新一线城市预购X车价格" prop="newFirstCityPreOrderPrices" >
            <a-input-number v-model="form.newFirstCityPreOrderPrices" :min="0" :step="1" :precision="0" placeholder="请输入新一线城市预购X车价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="新一线城市再领一本价格" prop="newFirstCityOrderPrices" >
            <a-input-number v-model="form.newFirstCityOrderPrices" :min="20" :max="1000" placeholder="请输入新一线城市再领一本价格" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="48">
        <a-col :span="8">
          <a-form-model-item label="二线城市开本价格" prop="secondCityPrices" >
            <a-input-number v-model="form.secondCityPrices" :min="20" :max="1000" placeholder="请输入二线城市开本价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="二线城市预购X车价格" prop="secondCityPreOrderPrices" >
            <a-input-number v-model="form.secondCityPreOrderPrices" :min="0" :step="1" :precision="0" placeholder="请输入二线城市预购X车价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="二线城市再领一本价格" prop="secondCityOrderPrices" >
            <a-input-number v-model="form.secondCityOrderPrices" :min="20" :max="1000" placeholder="请输入二线城市再领一本价格" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="48">
        <a-col :span="8">
          <a-form-model-item label="三线城市开本价格" prop="thirdCityPrices" >
            <a-input-number v-model="form.thirdCityPrices" :min="20" :max="1000" placeholder="请输入三线城市开本价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="三线城市预购X车价格" prop="thirdCityPreOrderPrices" >
            <a-input-number v-model="form.thirdCityPreOrderPrices" :min="0" :step="1" :precision="0" placeholder="请输入三线城市预购X车价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="三线城市再领一本价格" prop="thirdCityOrderPrices" >
            <a-input-number v-model="form.thirdCityOrderPrices" :min="20" :max="1000" placeholder="请输入三线城市再领一本价格" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="48">
        <a-col :span="8">
          <a-form-model-item label="四线城市价格" prop="fourthCityPrices" >
            <a-input-number v-model="form.fourthCityPrices" :min="20" :max="1000" placeholder="请输入四线城市价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="四线城市预购X车价格" prop="fourthCityPreOrderPrices" >
            <a-input-number v-model="form.fourthCityPreOrderPrices" :min="0" :step="1" :precision="0" placeholder="请输入四线城市预购X车价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="四线城市再领一本价格" prop="fourthCityOrderPrices" >
            <a-input-number v-model="form.fourthCityOrderPrices" :min="20" :max="1000" placeholder="请输入四线城市再领一本价格" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="48">
        <a-col :span="8">
          <a-form-model-item label="五线城市价格" prop="fifthCityPrices" >
            <a-input-number v-model="form.fifthCityPrices" :min="20" :max="1000" style="width: 100%" placeholder="请输入五线城市价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="五线城市预购X车价格" prop="fifthCityPreOrderPrices" >
            <a-input-number v-model="form.fifthCityPreOrderPrices" :min="0" :step="1" :precision="0" placeholder="请输入五线城市预购X车价格" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="五线城市再领一本价格" prop="fifthCityOrderPrices" >
            <a-input-number v-model="form.fifthCityOrderPrices" :min="20" :max="1000" style="width: 100%" placeholder="请输入五线城市再领一本价格" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-form-model-item label="dm人数" prop="dmNum" >
        <a-input-number v-model="form.dmNum" :min="0" :max="9" placeholder="请输入dm人数" />
      </a-form-model-item>
      <a-form-model-item label="npc人数" prop="npcNum" >
        <a-input-number v-model="form.npcNum" :min="0" :max="9" placeholder="请输入npc人数" />
      </a-form-model-item>
      <a-form-model-item label="是否反串" prop="isAllowReverse" >
        <a-switch v-model="form.isAllowReverse" /> {{ form.isAllowReverse ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="演绎时间-文字范围" prop="performanceTime" >
        <a-input v-model="form.performanceTime" placeholder="请输入演绎时间-文字范围" />
      </a-form-model-item>
      <a-form-model-item label="单人阅读量-文字" prop="singlePersonReadVolume" >
        <a-input v-model="form.singlePersonReadVolume" placeholder="请输入单人阅读量-文字" />
      </a-form-model-item>
      <a-form-model-item label="自定义标签" prop="customLabels" >
        <template v-for="(tag, index) in tags">
          <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
            <a-tag :key="tag" :closable="true" @close="() => handleClose(tag)">
              {{ `${tag.slice(0, 20)}...` }}
            </a-tag>
          </a-tooltip>
          <a-tag v-else :key="tag" :closable="true" @close="() => handleClose(tag)">
            {{ tag }}
          </a-tag>
        </template>
        <a-input
          v-if="inputVisible"
          ref="input"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          :value="inputValue"
          @change="handleInputChange"
          @blur="handleInputConfirm"
          @keyup.enter="handleInputConfirm"
        />
        <a-tag v-else style="background: #fff; borderStyle: dashed;" @click="showInput">
          <a-icon type="plus" /> 新标签
        </a-tag>
      </a-form-model-item>
      <a-form-model-item label="是否送剧本" prop="isHandselScript" >
        <a-switch v-model="form.isHandselScript" /> {{ form.isHandselScript ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="是否多结局" prop="isMultipleEndings" >
        <a-switch v-model="form.isMultipleEndings" /> {{ form.isMultipleEndings ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="是否可申领" prop="isApply" >
        <a-switch v-model="form.isApply" @change="changeApply" /> {{ form.isApply ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="三方申领数量" prop="thirdPartyApplyCount">
        <a-input-number v-model="form.thirdPartyApplyCount" :min="0" :step="1" :precision="0" placeholder="请输入三方申领数量"/>
      </a-form-model-item>
      <a-form-model-item label="开放申领时间" prop="openApplyTime">
        <a-date-picker
          style="width: 100%"
          v-model="form.openApplyTime"
          @change="onDateChange"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="预计发货任务日期" prop="expectedShippingMissionDate" >
        <a-date-picker
          style="width: 100%"
          v-model="form.expectedShippingMissionDate"
          @change="onDateChange1"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="剧本配套标签" prop="scriptPackageLabels" >
        <a-input v-model="form.scriptPackageLabels" placeholder="请输入剧本配套标签" />
      </a-form-model-item>
      <a-form-model-item label="剧本亮点" prop="scriptHighlights" >
        <a-input v-model="form.scriptHighlights" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="其他说明" prop="otherNotes" >
        <a-input v-model="form.otherNotes" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="是否含有勘误" prop="isHaveErrata" >
        <a-switch v-model="form.isHaveErrata" @change="changeApply" /> {{ form.isApply ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="勘误文档" prop="errataDocument" v-if="form.isHaveErrata">
        <div style="position: relative;">
          <a-textarea v-model="form.errataDocument" :max-length="255" :rows="3" placeholder="请输入勘误文档"/>
          <div style="position: absolute; bottom: 0; right: 10px; color: rgba(0,0,0,0.45); font-size: 12px;">
            {{ (form.errataDocument || '').length }}/255
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="打本/售后电子信息" prop="playedElectronicInfo" >
        <div style="position: relative;">
          <a-textarea v-model="form.playedElectronicInfo" :max-length="255" :rows="3" placeholder="请输入打本/售后电子信息"/>
          <div style="position: absolute; bottom: 0; right: 10px; color: rgba(0,0,0,0.45); font-size: 12px;">
            {{ (form.playedElectronicInfo || '').length }}/255
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item label="是否可购买开本卷包" prop="openVolumePackagePurchasable" >
        <a-switch v-model="form.openVolumePackagePurchasable" @change="changeOpenVolumePackagePurchasable" /> {{ form.openVolumePackagePurchasable ? '是' : '否' }}
      </a-form-model-item>
      <a-form-model-item label="卷包中卷的数量" prop="volumeCount" >
        <a-input v-model="form.volumeCount" placeholder="卷包中卷的数量(例:[5,10] 第一个卷包里有5张卷 第二个卷包里有10张卷 以此类推)" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>

    <index-script-modal
      ref="IndexScriptModal"
      :excludePlayedScript="true"
      @select="indexScriptModalSelect"
      @selectName="indexScriptModalName"
    ></index-script-modal>
  </a-drawer>
</template>

<script>
import { addScript, getScript, updateScript } from '@/api/played/script'
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssMultiUpload,
    IndexScriptModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        scriptId: null,
        thirdPartyApplyCount: undefined,
        bannerImg: null,
        dmNum: null,
        npcNum: null,
        isAllowReverse: undefined,
        performanceTime: null,
        singlePersonReadVolume: null,
        customLabels: null,
        scriptPackageLabels: null,
        scriptHighlights: null,
        otherNotes: null,
        firstCityPrices: null,
        newFirstCityPrices: null,
        secondCityPrices: null,
        thirdCityPrices: null,
        fourthCityPrices: null,
        fifthCityPrices: null,
        applyWay: undefined,
        preOrderCarNum: null,
        firstCityOrderPrices: null,
        newFirstCityOrderPrices: null,
        secondCityOrderPrices: null,
        thirdCityOrderPrices: null,
        fourthCityOrderPrices: null,
        fifthCityOrderPrices: null,
        quickPlayedPrices: null,
        isHandselScript: undefined,
        openApplyTime: null,
        expectedShippingMissionDate: null,
        isHaveErrata: undefined,
        errataDocument: null,
        playedElectronicInfo: null,
        isMultipleEndings: null,
        isApply: false,
        volumeCount: '[]',
        openVolumePackagePurchasable: false,
        freeToPreorderThreshold: null,
        firstCityPreOrderPrices: null,
        newFirstCityPreOrderPrices: null,
        secondCityPreOrderPrices: null,
        thirdCityPreOrderPrices: null,
        fourthCityPreOrderPrices: null,
        fifthCityPreOrderPrices: null,
        anotherCount: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        scriptId: [
          { required: true, message: '剧本id不能为空', trigger: 'blur' }
        ],
        firstCityPrices: [
          { required: true, message: '一线城市价格不能为空', trigger: 'blur' }
        ],
        newFirstCityPrices: [
          { required: true, message: '新一线城市价格不能为空', trigger: 'blur' }
        ],
        secondCityPrices: [
          { required: true, message: '二线城市价格不能为空', trigger: 'blur' }
        ],
        thirdCityPrices: [
          { required: true, message: '三线城市价格不能为空', trigger: 'blur' }
        ],
        fourthCityPrices: [
          { required: true, message: '四线城市价格不能为空', trigger: 'blur' }
        ],
        fifthCityPrices: [
          { required: true, message: '五线城市价格不能为空', trigger: 'blur' }
        ],
        preOrderCarNum: [
          { required: true, message: '预购车数量不能为空', trigger: 'blur' }
        ],
        anotherCount: [
          { required: true, message: '再领一本数量不能为空', trigger: 'blur' }
        ],
        firstCityOrderPrices: [
          { required: true, message: '一线城市再领一本价格不能为空', trigger: 'blur' }
        ],
        newFirstCityOrderPrices: [
          { required: true, message: '新一线城市再领一本价格不能为空', trigger: 'blur' }
        ],
        secondCityOrderPrices: [
          { required: true, message: '二线城市再领一本价格不能为空', trigger: 'blur' }
        ],
        thirdCityOrderPrices: [
          { required: true, message: '三线城市再领一本价格不能为空', trigger: 'blur' }
        ],
        fourthCityOrderPrices: [
          { required: true, message: '四线城市再领一本价格不能为空', trigger: 'blur' }
        ],
        fifthCityOrderPrices: [
          { required: true, message: '五线城市再领一本价格不能为空', trigger: 'blur' }
        ],
        firstCityPreOrderPrices: [
          { required: true, message: '一线城市预购X车价格不能为空', trigger: 'blur' }
        ],
        newFirstCityPreOrderPrices: [
          { required: true, message: '新一线城市预购X车价格不能为空', trigger: 'blur' }
        ],
        secondCityPreOrderPrices: [
          { required: true, message: '二线城市预购X车价格不能为空', trigger: 'blur' }
        ],
        thirdCityPreOrderPrices: [
          { required: true, message: '三线城市预购X车价格不能为空', trigger: 'blur' }
        ],
        fourthCityPreOrderPrices: [
          { required: true, message: '四线城市预购X车价格不能为空', trigger: 'blur' }
        ],
        fifthCityPreOrderPrices: [
          { required: true, message: '五线城市预购X车价格不能为空', trigger: 'blur' }
        ],
        quickPlayedPrices: [
          { required: true, message: '快速开本价格不能为空', trigger: 'blur' }
        ],
        errataDocument: [
          { required: true, message: '勘误文档不能为空', trigger: 'blur' }
        ]
      },
      tags: [],
      inputVisible: false,
      inputValue: ''
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    indexScriptModalSelect(ids) {
      this.form.scriptId = ids
      console.log('获取到的ids', ids)
    },
    indexScriptModalName(name) {
      this.form.scriptName = name
      console.log('获取到的剧本名', name)
    },
    showBindScript: function() {
      this.$refs.IndexScriptModal.open()
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        scriptId: null,
        thirdPartyApplyCount: undefined,
        bannerImg: null,
        dmNum: null,
        npcNum: null,
        isAllowReverse: undefined,
        performanceTime: null,
        singlePersonReadVolume: null,
        customLabels: null,
        scriptPackageLabels: null,
        scriptHighlights: null,
        otherNotes: null,
        firstCityPrices: null,
        newFirstCityPrices: null,
        secondCityPrices: null,
        thirdCityPrices: null,
        fourthCityPrices: null,
        fifthCityPrices: null,
        applyWay: undefined,
        preOrderCarNum: null,
        firstCityOrderPrices: null,
        newFirstCityOrderPrices: null,
        secondCityOrderPrices: null,
        thirdCityOrderPrices: null,
        fourthCityOrderPrices: null,
        fifthCityOrderPrices: null,
        quickPlayedPrices: null,
        isHandselScript: undefined,
        openApplyTime: null,
        expectedShippingMissionDate: null,
        isHaveErrata: undefined,
        errataDocument: null,
        playedElectronicInfo: null,
        isMultipleEndings: null,
        isApply: false,
        volumeCount: '[]',
        openVolumePackagePurchasable: false,
        freeToPreorderThreshold: null,
        firstCityPreOrderPrices: null,
        newFirstCityPreOrderPrices: null,
        secondCityPreOrderPrices: null,
        thirdCityPreOrderPrices: null,
        fourthCityPreOrderPrices: null,
        fifthCityPreOrderPrices: null,
        anotherCount: null
      }
      this.tags = []
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const scriptId = row ? row.scriptId : ids
      getScript(scriptId).then(response => {
        this.form = response.data
        this.tags = this.form.customLabels.split(',')
        this.open = true
        this.formTitle = '修改'
      })
    },
    isValidJSONArrayFlexible(str) {
      if (typeof str !== 'string') return false

      // 移除首尾空白
      const trimmed = str.trim()
      if (trimmed.length === 0) return false

      // 检查是否以[开头，]结尾
      if (!trimmed.startsWith('[') || !trimmed.endsWith(']')) return false

      // 提取内部内容
      const innerContent = trimmed.substring(1, trimmed.length - 1).trim()

      // 如果是空数组
      if (innerContent === '') return false

      // 分割内容
      const items = innerContent.split(',').map(item => item.trim())

      // 检查每个元素是否为有效数字
      for (const item of items) {
        if (item === '' || isNaN(Number(item)) || !/^\d+(\.\d+)?$/.test(item)) {
          return false
        }
      }

      return true
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 使用逗号加空格作为分隔符
          this.form.customLabels = this.tags.join(',')
          this.submitLoading = true
          if (this.form.openVolumePackagePurchasable) {
            if (!this.isValidJSONArrayFlexible(this.form.volumeCount)) {
              this.$message.error(
                '卷包中卷的数量 数据格式错误 正确格式参考示例[5,10]',
                3
              )
              this.submitLoading = false
              return
            }
          } else {
            this.form.volumeCount = '[]'
          }
          if (this.formType === 2) {
            updateScript(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addScript(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    changeApply (val) {
      if (!val) {
        this.form.openApplyTime = null
      }
    },
    changeOpenVolumePackagePurchasable (val) {
      if (!val) {
        this.form.volumeCount = '[]'
      }
    },
    onDateChange(date, dateString) {
      this.form.openApplyTime = dateString
    },
    onDateChange1(date, dateString) {
      this.form.expectedShippingMissionDate = dateString
    },

    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag)
      console.log(tags)
      this.tags = tags
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(function() {
        this.$refs.input.focus()
      })
    },
    handleInputChange(e) {
      this.inputValue = e.target.value
    },
    handleInputConfirm() {
      const inputValue = this.inputValue
      let tags = this.tags
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue]
      }
      console.log(tags)
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: ''
      })
    }
  }
}
</script>
